(() => {
  const config = JSON.parse(document.getElementById('FlowwoConfig')?.textContent || '{}');
  const strings = config.strings || {};
  const rootUrl = config.root || '/';
  const money = cents => new Intl.NumberFormat(config.locale || 'en-US', {style: 'currency', currency: config.currency || 'USD', minimumFractionDigits: cents % 100 ? 2 : 0}).format(cents / 100);
  document.documentElement.classList.replace('no-js', 'js');
  let lastFocus = null;
  let cartBusy = false;
  const announce = text => { const el = document.getElementById('FlowwoStatus'); if (el) el.textContent = text; };
  function openDialog(dialog, trigger) {
    if (!dialog || dialog.open) return;
    lastFocus = trigger || document.activeElement;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
    dialog.querySelector('video')?.play().catch(() => {});
  }
  function closeDialog(dialog) {
    if (!dialog) return;
    dialog.close();
    dialog.querySelectorAll('video').forEach(video => video.pause());
    document.documentElement.style.overflow = '';
    if (lastFocus?.isConnected) lastFocus.focus({preventScroll: true});
  }
  async function request(url, options) {
    const response = await fetch(url, {credentials: 'same-origin', ...options});
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(typeof data.description === 'string' ? data.description : data.message || strings.error);
    return data;
  }
  function renderCart(sections) {
    const html = sections?.['cart-drawer'];
    if (!html) return false;
    const fragment = new DOMParser().parseFromString(html, 'text/html');
    const fresh = fragment.querySelector('[data-cart-content]');
    const current = document.querySelector('#ShoppingBag [data-cart-content]');
    if (!fresh || !current) return false;
    current.replaceWith(fresh);
    document.querySelectorAll('[data-cart-count]').forEach(el => {el.textContent = fresh.dataset.renderedCount;});
    return true;
  }
  async function refreshCart() {
    const url = new URL(rootUrl, location.origin);
    url.searchParams.set('sections', 'cart-drawer');
    const response = await fetch(url, {credentials: 'same-origin', cache: 'no-store'});
    if (!response.ok || !renderCart(await response.json())) throw new Error(strings.error);
  }
  function showMedia(section, id) {
    if (!id) return;
    const panels = section.querySelectorAll('[data-media-panel]');
    if (![...panels].some(panel => panel.dataset.mediaPanel === String(id))) return;
    panels.forEach(panel => {
      const active = panel.dataset.mediaPanel === String(id);
      panel.hidden = !active;
      if (!active) panel.querySelectorAll('video').forEach(v => v.pause());
    });
    section.querySelectorAll('[data-media-target]').forEach(button => {
      const active = button.dataset.mediaTarget === String(id);
      button.setAttribute('aria-pressed', String(active));
      button.classList.toggle('selected', active);
    });
    const panel = [...panels].find(panel => !panel.hidden);
    const image = panel?.querySelector('img');
    const zoom = section.querySelector('[data-image-zoom]');
    if (zoom) zoom.hidden = !image || id === 'flowwo-3d';
    if (id === 'flowwo-3d') section.dispatchEvent(new CustomEvent('flowwo:show-model', {bubbles: true}));
  }
  function initProduct(section) {
    if (section.dataset.ready) return;
    section.dataset.ready = 'true';
    const variants = JSON.parse(section.querySelector('[data-variant-data]')?.textContent || '{}').variants || [];
    const form = section.querySelector('.flowwo-product-form');
    if (!form) return;
    const select = form.querySelector('[data-variant-select]');
    const quantity = form.querySelector('[name="quantity"]');
    const add = form.querySelector('[data-add-to-cart]');
    const options = [...form.querySelectorAll('[data-option-position]')].sort((a,b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition));
    let chosen = variants.find(variant => String(variant.id) === select.value);
    const updatePurchase = () => {
      const available = Boolean(chosen?.available);
      add.disabled = !available || form.dataset.busy === 'true';
      const label = form.querySelector('[data-add-label]');
      label.textContent = form.dataset.busy === 'true' ? strings.loading : chosen ? available ? `${strings.add} — ${money(chosen.price * Number(quantity.value || 1))}` : strings.sold : strings.unavailable;
      const payment = form.querySelector('[data-payment]');
      if (payment) payment.hidden = !available;
      const status = form.querySelector('[data-availability]');
      if (status) status.textContent = chosen ? available ? strings.available : strings.sold : strings.unavailable;
    };
    const update = (changeMedia = true, updateUrl = true) => {
      const values = options.map(field => field.querySelector('input:checked')?.value);
      if (options.length) chosen = variants.find(variant => variant.options.every((value, index) => value === values[index]));
      else chosen = variants.find(variant => String(variant.id) === select.value);
      select.value = chosen ? String(chosen.id) : '';
      if (chosen) {
        section.querySelector('[data-variant-price]').textContent = chosen.price_text;
        const compare = section.querySelector('[data-variant-compare]');
        const discount = section.querySelector('[data-variant-discount]');
        compare.hidden = discount.hidden = !(chosen.compare > chosen.price);
        compare.textContent = chosen.compare_text;
        discount.textContent = (strings.discount || '__percent__% OFF').replace('__percent__', String(Math.round((chosen.compare - chosen.price) * 100 / chosen.compare)));
        quantity.min = chosen.min || 1;
        quantity.step = chosen.step || 1;
        if (chosen.max) quantity.max = chosen.max; else quantity.removeAttribute('max');
        quantity.value = Math.max(chosen.min || 1, Math.min(Number(quantity.value), chosen.max || Infinity));
        if (changeMedia && chosen.media_id) showMedia(section, chosen.media_id);
      }
      options.forEach((field, position) => {
        const checked = field.querySelector('input:checked');
        field.querySelector('[data-option-label]').textContent = checked?.value || '';
        field.querySelectorAll('label.choice').forEach(label => {
          const radio = label.querySelector('input');
          label.classList.toggle('selected', radio.checked);
          const candidate = [...values]; candidate[position] = radio.value;
          const available = variants.some(variant => variant.available && variant.options.every((value,index) => value === candidate[index]));
          label.classList.toggle('unavailable', !available);
        });
      });
      if (updateUrl && location.pathname.includes('/products/')) {
        const url = new URL(location.href);
        if (chosen) url.searchParams.set('variant', chosen.id); else url.searchParams.delete('variant');
        history.replaceState({}, '', url);
      }
      select.dispatchEvent(new Event('change', {bubbles: true}));
      updatePurchase();
    };
    form.addEventListener('change', event => {if (event.target.matches('[data-product-option]')) update();});
    quantity.addEventListener('input', updatePurchase);
    form.addEventListener('flowwo:busy', updatePurchase);
    form.querySelector('[data-personalization]')?.addEventListener('input', event => {form.querySelector('[data-personalization-count]').textContent = event.target.value.length;});
    update(false, false);
  }
  function initCarousel(carousel) {
    if (carousel.dataset.ready) return;
    carousel.dataset.ready = 'true';
    const track = carousel.querySelector('[data-craft-track]');
    const count = carousel.querySelector('[data-craft-count]');
    const slides = [...track.children];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    const index = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const go = delta => {track.scrollTo({left: ((index() + delta + slides.length) % slides.length) * track.clientWidth, behavior: reduced.matches ? 'instant' : 'smooth'});};
    carousel.querySelector('[data-craft-prev]').addEventListener('click', () => go(-1));
    carousel.querySelector('[data-craft-next]').addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => {count.textContent = `${String(index() + 1).padStart(2,'0')} / ${String(slides.length).padStart(2,'0')}`;}, {passive:true});
  }
  function init(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(initProduct);
    scope.querySelectorAll('[data-craft-carousel]').forEach(initCarousel);
    scope.querySelectorAll('dialog').forEach(dialog => {
      if (dialog.dataset.ready) return;
      dialog.dataset.ready = 'true';
      dialog.addEventListener('cancel', event => {event.preventDefault(); closeDialog(dialog);});
      dialog.addEventListener('click', event => {
        const r = dialog.getBoundingClientRect();
        if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) closeDialog(dialog);
      });
    });
    scope.querySelectorAll('[data-dialog-open]').forEach(button => {if (!document.getElementById(button.dataset.dialogOpen)) button.hidden = true;});
  }
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.flowwo-product-form') || !event.submitter?.matches('[data-add-to-cart]')) return;
    event.preventDefault();
    if (form.dataset.busy === 'true' || !form.reportValidity()) return;
    const error = form.querySelector('[data-product-error]');
    error.hidden = true;
    form.dataset.busy = 'true';form.dispatchEvent(new Event('flowwo:busy'));
    const data = new FormData(form);
    data.set('sections','cart-drawer');data.set('sections_url',location.pathname);
    if (!data.get('properties[Personalization]')?.trim()) data.delete('properties[Personalization]');
    try {
      const result = await request(`${config.add}.js`, {method:'POST', body:data});
      if (!renderCart(result.sections)) {
        try {await refreshCart();} catch {location.assign(config.cart);return;}
      }
      announce(strings.added);
      openDialog(document.getElementById('ShoppingBag'), event.submitter);
    } catch (failure) {error.textContent = failure.message || strings.error;error.hidden = false;}
    finally {delete form.dataset.busy;form.dispatchEvent(new Event('flowwo:busy'));}
  });
  async function changeCart(control, quantity) {
    const form = control.closest('form');
    if (control.closest('.cart-page')) {
      const line = control.closest('.bag-line');
      line.querySelector('[name="updates[]"]').value = Math.max(0, quantity);
      form.requestSubmit(form.querySelector('[name="update"]'));
      return;
    }
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    cartBusy = true;
    const content = document.querySelector('#ShoppingBag [data-cart-content]');
    content.setAttribute('aria-busy','true');
    content.querySelectorAll('button,input').forEach(el=>el.disabled=true);
    try {
      const result = await request(`${config.change}.js`, {method:'POST', headers:{'Content-Type':'application/json'}, body:JSON.stringify({id:control.dataset.cartKey,quantity,sections:['cart-drawer'],sections_url:location.pathname})});
      if (!renderCart(result.sections)) await refreshCart();
    } catch (failure) {
      const error = content.querySelector('[data-cart-error]');
      if (error) {error.textContent = failure.message || strings.error;error.hidden = false;}
    } finally {
      cartBusy = false;
      const updated = document.querySelector('#ShoppingBag [data-cart-content]');
      updated.removeAttribute('aria-busy');
      updated.querySelectorAll('button,input').forEach(el=>el.disabled=false);
    }
  }
  document.addEventListener('change', event => {if (event.target.matches('[data-cart-quantity]')) changeCart(event.target,Number(event.target.value));});
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-dialog-open]');
    if (opener) {event.preventDefault();openDialog(document.getElementById(opener.dataset.dialogOpen),opener);}
    const close = event.target.closest('[data-dialog-close]');
    if (close) {event.preventDefault();closeDialog(close.closest('dialog'));}
    const menuLink = event.target.closest('#MobileMenu a');
    if (menuLink) closeDialog(menuLink.closest('dialog'));
    const cartOpen = event.target.closest('[data-cart-open]');
    if (cartOpen) {
      event.preventDefault();
      try {await refreshCart();openDialog(document.getElementById('ShoppingBag'),cartOpen);} catch {location.assign(config.cart);}
    }
    const cartChange = event.target.closest('[data-cart-change]');
    if (cartChange) {event.preventDefault();changeCart(cartChange,Number(cartChange.dataset.quantity));}
    const stepper = event.target.closest('[data-quantity-step]');
    if (stepper) {
      const input = stepper.closest('.quantity-control').querySelector('input');
      if (Number(stepper.dataset.quantityStep)>0) input.stepUp();else input.stepDown();
      input.dispatchEvent(new Event('input',{bubbles:true}));
    }
    const media = event.target.closest('[data-media-target]');
    if (media) showMedia(media.closest('[data-product-section]'),media.dataset.mediaTarget);
    const thumbnails = event.target.closest('[data-thumbnails-prev],[data-thumbnails-next]');
    if (thumbnails) {const track=thumbnails.closest('.thumbnail-carousel').querySelector('[data-thumbnails]');track.scrollBy({left:track.clientWidth*.6*(thumbnails.hasAttribute('data-thumbnails-next')?1:-1),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    const zoom = event.target.closest('[data-image-zoom]');
    if (zoom) {
      const gallery = zoom.closest('[data-product-gallery]');
      const img = gallery.querySelector('[data-media-panel]:not([hidden]) img');
      if (img) {const dialog=gallery.querySelector('[data-zoom-dialog]');const target=dialog.querySelector('[data-zoom-image]');target.src=img.currentSrc||img.src;target.alt=img.alt;openDialog(dialog,zoom);}
    }
    const motion = event.target.closest('[data-motion-toggle]');
    if (motion) {
      const paused = motion.getAttribute('aria-pressed')!=='true';
      motion.setAttribute('aria-pressed',String(paused));motion.querySelector('span').textContent=paused?motion.dataset.off:motion.dataset.on;
      document.dispatchEvent(new CustomEvent('flowwo:motion',{detail:{paused}}));
    }
  });
  document.addEventListener('shopify:section:load',event=>init(event.target));
  document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('dialog[open]').forEach(closeDialog));
  window.addEventListener('pageshow',event=>{if(event.persisted)refreshCart().catch(()=>{});});
  init();
})();
